export default __webpack_public_path__ + "d30028dc806d31411f82af8e01622a0d.png";